import { memo, useRef, useState } from "react";
import { makeStyles, } from '@material-ui/core';
import ReactPlayer from 'react-player'
import { useSelector } from "react-redux";

const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 10,
    margin: 'auto',
    paddingTop: 20,
    '@media screen and (max-width: 1300px)': {
      paddingTop: 0,
    }
  },
}));

function VideoImage(props: any) {

  const classes = useStyles();
  const { videoStart, videoEnd, video, small } = props;
  const playerRef: any = useRef(null);
  const [count, setCount] = useState(0);
  const [playing, setPlaying] = useState(true);

  const { analyseStart, settings } = useSelector((state: any) => state.analysis);
  const { pdfLoading, videoBase64Img } = settings;

  // const isPrivateURL = video.includes('https://metasalt-youtube-dev.s3.amazonaws.com/');
  const isVimeo = video.includes('https://vimeo.com/');
  const isYoutube = video.includes('youtube.com/') || video.includes('youtube.com/');

  const onReady = async () => {
    await playerRef?.current?.seekTo((videoStart > 10000 ? (videoStart - analyseStart) : videoStart) || 1)
  }

  const onPlay = () => {

    if (isYoutube) {
      if (count < 1) {
        try {
          playerRef?.current?.getInternalPlayer()?.pauseVideo()
        } catch {

        }
      }
      setCount(2)
      return false;
    }

    if (isVimeo) {
      setTimeout(() => {
        setPlaying(false);
      }, 500)
    }

  }

  return (
    <div className={classes.container} style={small ? { paddingTop: 0 } : {}}>
      {(pdfLoading && videoBase64Img) ?
        <img src={videoBase64Img} alt='thumbnail' style={{ width: small ? 250 : 530, height: small ? 167 : 289 }} /> :
        <ReactPlayer
          style={{ pointerEvents: "none" }}
          width={small ? 250 : 530}
          height={small ? 167 : 289}
          url={video}
          ref={playerRef}
          onReady={onReady}
          onPlay={onPlay}
          playing={(isVimeo && playing) || isYoutube}
          vimeoconfig={{ iframeParams: { fullscreen: 0 } }}
          muted={true}
          config={{
            youtube: {
              playerVars: {
                start: videoStart,
                end: videoEnd,
                modestBranding: 1,
                playsInline: 1,
                rel: 0,
                showInfo: 0,
                showSearch: 0,
                mute: 1,
                controls: 0,
                ecver: 2,
              },
              embedOptions: {

              }
            },
            vimeo: {
              playerOptions: {
                rel: 0
              }
            }
          }}
        />}

    </div>
  );
}

export default memo(VideoImage);